/**
 * MOVENMUSE FRONTEND - MAIN ENTRY POINT
 * 
 * This is the main entry point for the MovenMuse React frontend application.
 * It initializes the React app and sets up the routing and context providers.
 * 
 * SETUP:
 * - React 18 with createRoot API
 * - BrowserRouter for clean URLs
 * - UserProvider for global user state management
 * - Bootstrap CSS for styling
 * - Web Vitals monitoring for performance
 *
 * ROUTING:
 * - Uses BrowserRouter for clean URLs (e.g., /festivals instead of /#/festivals)
 * - All routes are defined in Router.js
 * 
 * CONTEXT:
 * - UserProvider wraps the entire app for user authentication state
 */
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/bootstrap-custom.scss";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./context/UserContext";

// Create React root for React 18
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render the main application with providers
root.render(
  <BrowserRouter>
    <UserProvider>
      <App />
    </UserProvider>
  </BrowserRouter>
);

// Performance monitoring - only in development
// In production, you can send this data to analytics services
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} else {
  // In production, you might want to send to analytics
  // reportWebVitals(sendToAnalytics);
  reportWebVitals();
}
